import React, { Component } from 'react'
import { Modal, Button, Checkbox } from 'antd'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import { services as apiServices } from '@services/api'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
export default class ManageServicesForSubs extends Component<any, any> {
    constructor(props) {
        super(props)
        this.closePopup = this.closePopup.bind(this)
        this.state = { services: [] }
    }

    closePopup = () => this.props.popupStore.togglePopup(false)

    async componentDidUpdate() {
        const { popupType, info } = this.props.popupStore
        if (popupType == 'manageServicesForSubs' && !this.state.services.length) {
            let servicesList = (await apiServices.servicesList()).data
            const { services, subId } = toJS(info)
            this.setState({
                services: servicesList.map(apiServ =>
                    services.map(ser => ser.pivot.service_id).includes(apiServ.id)
                        ? {
                              name: services.find(ser => ser.pivot.service_id == apiServ.id).name,
                              ...services.find(ser => ser.pivot.service_id == apiServ.id).pivot
                          }
                        : { price: null, subscription_id: subId, name: apiServ.name, service_id: apiServ.id }
                )
            })
        } else if (!popupType && this.state.services.length) {
            this.setState({ services: [] })
        }
    }
    render() {
        const { popupType } = this.props.popupStore
        const { services } = this.state
        const footerButtons = (
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
                <Button
                    onClick={async () => {
                        await apiServices
                            .updateServicePrice(this.state.services)
                            .then(() => {
                                this.props.refreshSubs()
                                this.closePopup()
                            })
                            .catch(err => console.log(err))
                    }}
                >
                    שמור שינויים
                </Button>
            </div>
        )

        return (
            <Modal
                title={`תמחור שירותים למנוי`}
                visible={popupType === 'manageServicesForSubs'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
                width={1200}
            >
                {services.map(service => (
                    <div
                        style={{
                            flexDirection: 'row',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <span
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '65%',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Checkbox
                                checked={service.price !== null}
                                onChange={() =>
                                    this.setState(prev => ({
                                        services: prev.services.map(ser =>
                                            ser.name == service.name
                                                ? { ...ser, price: service.price !== null ? null : 0 }
                                                : ser
                                        )
                                    }))
                                }
                            />
                            {service.name}
                            <input
                                style={{ width: 60, textAlign: 'center' }}
                                value={service.price || 0}
                                disabled={service.price === null}
                                type="number"
                                onChange={e => {
                                    let price = e.target.value
                                    this.setState(prev => ({
                                        services: prev.services.map(ser =>
                                            ser.name == service.name ? { ...ser, price } : ser
                                        )
                                    }))
                                }}
                            />
                        </span>
                    </div>
                ))}
            </Modal>
        )
    }
}
